'use client';

import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

export const BillingProfileAutoComplete = ({ id, handleChange, options, selectedOption, disabled, error }) => (
	<Autocomplete
		options={options.map((bp) => ({ name: bp.name, id: bp.id }))}
		value={selectedOption ? { name: selectedOption.name, id: selectedOption.id } : ''}
		freeSolo
		disabled={disabled}
		size='medium'
		isOptionEqualToValue={(option, value) => {
			if (typeof option === 'string' || typeof value === 'string') return false;
			return option?.id === value?.id;
		}}
		getOptionLabel={(option) => {
			if (typeof option === 'string') return '';
			return option.name;
		}}
		renderOption={(props, option) => {
			if (!option || typeof option === 'string') return null;
			return (
				<li {...props} key={`${id}-${option.id}`}>
					{option.name}
				</li>
			);
		}}
		renderInput={(params) => (
			<TextField
				{...params}
				value={selectedOption?.id || ''}
				inputProps={{ ...params.inputProps, 'data-cy': id }}
				error={error}
			/>
		)}
		onInputChange={(_, __, reason) => {
			if (reason === 'clear') handleChange(null);
		}}
		onChange={(_, value) => {
			if (!value || typeof value === 'string') return;
			const findSelection = options.find((bp) => bp.id === value.id);
			handleChange(findSelection);
		}}
	/>
);
